import { Home, BarChart3, Compass } from "lucide-react";

const Services = () => {
  const services = [
    {
      id: "cohosting",
      icon: Home,
      title: "Co-Hosting & Property Management",
      description:
        "We manage your Airbnb listing end-to-end — guest communications, pricing, reviews, and coordination — so you earn passive income without the daily work.",
      price: "From 20% commission · No upfront cost",
      color: "teal",
      testId: "service-card-cohosting",
      image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=600&q=80",
    },
    {
      id: "consulting",
      icon: BarChart3,
      title: "Listing Optimisation",
      description:
        "We audit your existing Airbnb listing and deliver a complete optimisation report covering title, photos, pricing strategy, and review management.",
      price: "From $350 per audit · Results within 7 days",
      color: "purple",
      testId: "service-card-consulting",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80",
    },
    {
      id: "experiences",
      icon: Compass,
      title: "Airbnb Experiences",
      description:
        "Join one of our locally hosted Bribie Island experiences — from kayak and wildlife tours to foodie walks and sunset photography.",
      price: "From $65 per person · Small groups only",
      color: "coral",
      testId: "service-card-experiences",
      image: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=600&q=80",
    },
  ];

  const getColorClasses = (color) => {
    switch (color) {
      case "teal":
        return {
          border: "border-teal-accent",
          bg: "hover:bg-teal-light/50",
          text: "text-teal",
          icon: "bg-teal-light text-teal",
        };
      case "purple":
        return {
          border: "border-purple-accent",
          bg: "hover:bg-purple-light/50",
          text: "text-purple",
          icon: "bg-purple-light text-purple",
        };
      case "coral":
        return {
          border: "border-coral-accent",
          bg: "hover:bg-coral-light/50",
          text: "text-coral",
          icon: "bg-coral-light text-coral",
        };
      default:
        return {
          border: "border-gold",
          bg: "hover:bg-gold-light/50",
          text: "text-gold",
          icon: "bg-gold-light text-gold",
        };
    }
  };

  return (
    <section
      id="services"
      data-testid="services-section"
      className="section-padding bg-white"
    >
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-[0.2em] text-gold font-semibold mb-4">
            Our Services
          </p>
          <h2 className="section-heading">
            Three ways we grow your Airbnb income
          </h2>
        </div>

        {/* Service Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const colors = getColorClasses(service.color);
            const Icon = service.icon;

            return (
              <div
                key={service.id}
                data-testid={service.testId}
                className={`service-card ${colors.border} ${colors.bg} group`}
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Image */}
                <div className="img-zoom mb-6 -mx-8 md:-mx-10 -mt-8 md:-mt-10">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-48 object-cover"
                  />
                </div>

                {/* Icon */}
                <div
                  className={`w-14 h-14 ${colors.icon} flex items-center justify-center mb-6`}
                >
                  <Icon size={28} />
                </div>

                {/* Content */}
                <h3 className="text-2xl font-serif text-bark mb-4">
                  {service.title}
                </h3>
                <p className="text-bark-light mb-6 leading-relaxed">
                  {service.description}
                </p>

                {/* Price */}
                <p className={`text-sm font-semibold ${colors.text} mb-4`}>
                  {service.price}
                </p>

                {/* Link */}
                <a
                  href="#contact"
                  className={`text-sm uppercase tracking-wider ${colors.text} font-semibold inline-flex items-center gap-2 group-hover:gap-3 transition-all`}
                >
                  Learn More
                  <span className="transition-transform group-hover:translate-x-1">
                    →
                  </span>
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
